import { useEffect } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { ThemeProvider } from '@nazka/nazka.mapframe.components'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { getAccessToken } from '@services/auth.service'
import { connectWebSocket, closeWebSocket } from '@services/websocket.service'
import { AuthProvider } from '@App/components/AuthProvider/AuthProvider'
import WebSocketQueryInvalidator from '@App/components/WebSocketQueryInvalidator/WebSocketQueryInvalidator'
import TranslationsProvider from '@utils/i18n/i18n'
import AppWindow from '@utils/AppWindow/AppWindow'
import ErrorBoundary from '@utils/ErrorBoundary/ErrorBoundary'
import routes from '@App/app.routes'
import { store, persistor } from '@App/app.store'
import translator from '@App/app.translator'
import theme from '@css/theme.style.json'

import './app.styl'

const router = createBrowserRouter(routes)
const queryClient = new QueryClient()

function App() {
  useEffect(() => {
    document.documentElement.setAttribute('data-app-initialised', true)
  }, [])

  useEffect(() => {
    getAccessToken()
      .then((token) => {
        connectWebSocket(token)
      })
      .catch(() => {
        closeWebSocket()
      })

    return () => {
      closeWebSocket()
    }
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <WebSocketQueryInvalidator />
      <AuthProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <ThemeProvider theme={theme}>
              <ErrorBoundary>
                <TranslationsProvider translator={translator}>
                  <RouterProvider router={router} />
                  <AppWindow />
                </TranslationsProvider>
              </ErrorBoundary>
            </ThemeProvider>
          </PersistGate>
        </Provider>
      </AuthProvider>
    </QueryClientProvider>
  )
}

export default App
